module.exports = __webpack_public_path__ + "media/images/weather/31_night_g-368dc2e372df10096b67d34355774aed.png";